import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { CourseState } from '../../types/course';

const initialState: CourseState = {
  isLoading: false,
  courseList: {},
  allCourses: [],
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.COURSE },
};

const slice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    courseStartLoading(state) {
      state.isLoading = true;
    },

    getAllCoursesSuccess(state, action) {
      state.allCourses = action.payload;
    },

    courseHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    courseResetError(state) {
      state.error = undefined;
    },

    getCourseListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getCourseSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setCourseListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearCourse(state) {
      state.course = undefined;
    },

    clearCourseList(state) {
      state.courseList = {};
    },

    clearCourseParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  courseStartLoading,
  courseHasError,
  courseResetError,
  getCourseListSuccess,
  getCourseSuccess,
  getAllCoursesSuccess,
  setCourseListParams,
  clearCourse,
  clearCourseParameters,
  clearCourseList,
} = slice.actions;
